var option_webview_default = {
  "option": "_5GxW6",
  "user_choice": "F86ei",
  "check": "Xa7ld",
  "image": "fMUYG",
  "input": "JV3px",
  "title": "_8Y0ZL",
  "centered": "bcc-W",
  "with_result": "fvSAN",
  "list": "MdwT1",
  "with_image": "q-snY",
  "progress": "fzWO8",
  "progress_value": "_5v7cs",
  "label": "R-DJ3",
  "cta": "ud3P3",
  "adornment_icon": "oyfGo",
  "remove": "jHdJy",
  "removeButton": "_5w2lU",
  "removeButtonIcon": "Q1yVV",
  "overlay": "iqxcX",
  "shown": "sKFpm",
  "dark": "_3H-f-",
  "spinner": "_6WJOm",
  "spin": "ki2dn",
  "grid": "bOsEd"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
